import { BlockTitle } from "@blocks/Blocks";

/**
 * Component to render SBA contact us page
 */
const SBAContactUsPage = (): React.ReactElement => {
  return (
    <div
      data-testid="sba-contact-us-page-component"
      className="font-public-sans"
    >
      <BlockTitle
        text="Contact Us"
        rootClassName="my-3 text-3xl md:text-5xl lg:text-11xl font-medium font-public-sans"
      />

      <p className="mb-6">
        For nominations or more information on Singapore Business Awards, please
        contact:
      </p>

      <ul className="mb-6">
        <li>
          <strong>Ong Yu Fan</strong>
        </li>
        <li>The Business Times</li>
        <li>1000 Toa Payoh North</li>
        <li>Podium Level 3, Singapore 318994</li>
      </ul>

      <ul className="mb-6">
        <li>Telephone: +65 6319 2235</li>
        <li>Email: yufanong@sph.com.sg</li>
      </ul>

      <ul className="mb-6">
        <li>
          <strong>Hannah Chng</strong>
        </li>
        <li>DHL Express (S) Pte Ltd</li>
        <li>DHL Air Express Centre</li>
        <li>No. 1 Tai Seng Drive, Singapore 535215</li>
      </ul>

      <ul className="mb-6">
        <li>Telephone: +65 6880 6581</li>
        <li>Email: hannah.chng@dhl.com</li>
      </ul>
    </div>
  );
};

export default SBAContactUsPage;
